// Scopes presented in the create-key dialog. Mirrors the taxonomy in
// packages/api/src/lib/v2/scopes.ts. Grouped by resource so the UI
// reads cleanly. Kept here (not imported) to avoid pulling server code
// into the bundle.

export const SCOPE_GROUPS: {
	title: string
	scopes: { id: string; label: string }[]
}[] = [
	{
		title: "Threads & messaging",
		scopes: [
			{ id: "threads:read", label: "Read threads" },
			{ id: "threads:write", label: "Write threads" },
			{ id: "messages:write", label: "Send messages" },
			{ id: "comments:write", label: "Post internal comments" },
		],
	},
	{
		title: "Contacts & companies",
		scopes: [
			{ id: "contacts:read", label: "Read contacts" },
			{ id: "contacts:write", label: "Write contacts" },
			{ id: "companies:read", label: "Read companies" },
			{ id: "companies:write", label: "Write companies" },
		],
	},
	{
		title: "Content",
		scopes: [
			{ id: "changelogs:read", label: "Read changelogs" },
			{ id: "changelogs:write", label: "Write changelogs" },
			{ id: "docs:read", label: "Read help center" },
			{ id: "docs:write", label: "Write help center" },
			{ id: "snippets:read", label: "Read snippets" },
			{ id: "snippets:write", label: "Write snippets" },
			{ id: "files:write", label: "Upload files (images, PDFs)" },
		],
	},
	{
		title: "Roadmap",
		scopes: [
			{ id: "projects:read", label: "Read projects" },
			{ id: "projects:write", label: "Write projects" },
			{ id: "issues:read", label: "Read issues" },
			{ id: "issues:write", label: "Write issues" },
			{ id: "portal:read", label: "Read public portal & customer portal" },
			{ id: "portal:write", label: "Write portals and their theme" },
		],
	},
	{
		title: "Agent",
		scopes: [
			{ id: "recommendations:read", label: "Read agent recommendations" },
			{
				id: "recommendations:write",
				label: "Accept and decline agent recommendations",
			},
			{
				id: "agent",
				label: "Call the A2A agent endpoint (/api/a2a)",
			},
		],
	},
	{
		title: "Admin",
		scopes: [
			{
				id: "admin",
				label: "Full admin (members, webhooks, all of the above)",
			},
		],
	},
]
